angular.module('bb.external').component('bbAppointmentListView', {
  bindings: {},
  controller: AppointmentListViewCtrl,
  controllerAs: 'vm',
  template: `<bb-external-appointment-list ng-if="vm.auth.externalDashboard"/>
               <bb-coop-appointment-list ng-if="vm.auth.coopDashboard"/>`,
});

AppointmentListViewCtrl.$inject = ['ExternalAuth'];

function AppointmentListViewCtrl(ExternalAuth) {
  const vm = this;
  vm.auth = ExternalAuth.auth;
}

export {};
